import commonService from "./ApiServiceClient";

// validate user
export const verify_otp_v2 = (params = {}) =>
  commonService.post("nirweb/verify_otp_v2", params);

// Fetch video home components
export const fetchVideoHomeComponents1 = (params = {}) =>
  commonService.post("uservideocontroler/fetch_video_home_components_data_v2", params);

export const fetchMoreVideoHomeComponents = (params = {}) =>
  commonService.post("uservideocontroler/fetch_video_home_components_more", params);

// Doctor Appointments
export const fetchPlayerDoctorAppointments = (params = {}) =>
  commonService.post("user/fetch_player_doctor_appointments_v2", params);

export const fetchDoctorAppointmentSlots = (params = {}) =>
  commonService.post("user/fetch_doctor_appointment_slots", params);

export const saveDoctorAppointmentSlots = (params = {}) =>
  commonService.post("/user/save_doctor_appointment", params);

export const cancelDoctorAppointment = (params = {}) =>
  commonService.post("/user/cancel_appointment", params);

export const fetchPlayerCoachAppointments = (params = {}) =>
  commonService.post("/user/fetch_player_coach_appointments", params);

export const fetchCoachAppointmentSlots = (params = {}) =>
  commonService.post("/user/coach_call_selected_slot", params);

export const saveCoachAppointmentSlots = (params = {}) =>
  commonService.post("/user/schedule_coach_appointment", params);

// Activity & Health Data
export const fetchDailyActivityRange = (params = {}) =>
  commonService.post("/band/fetch_daily_activity_range", params);

export const fetchWaterData = (params = {}) =>
  commonService.post("/water/fetch_by_range", params);

export const saveWaterLogData = (params = {}) =>
  commonService.post("/water/add_water", params);

export const deleteUserLogData = (params = {}) =>
  commonService.post("/water/remove_water", params);

export const saveActivityLogData = (params = {}) =>
  commonService.post("/activity/add_multiple_activity", params);

export const fetchWeightData = (params = {}) =>
  commonService.post("/weight/fetch_by_range", params);

export const saveWeightLogData = (params = {}) =>
  commonService.post("/weight/add_weight", params);

export const deleteUserWightLogEntry = (params = {}) =>
  commonService.post("/weight/remove_weight", params);

export const fetchSleepData = (params = {}) =>
  commonService.post("/sleep/fetch_by_range", params);

export const saveSleepLogData = (params = {}) =>
  commonService.post("/sleep/add_sleep", params);

export const deleteUserSleepLogEntry = (params = {}) =>
  commonService.post("/sleep/remove_sleep", params);

// User & Profile
export const fetchEntrypointData = (params = {}) =>
  commonService.post("/user/fetch_entrypoint_data", params);

export const fetchUserProfile = (params = {}) =>
  commonService.post("/ruser/fetch_profile", params);

export const editUserProfile = (params = {}) =>
  commonService.post("/user/edit_profile", params);

export const fetchFriendProfile = (params = {}) =>
  commonService.post("/ruser/fetch_friend_profile", params);

export const fetchUserHabits = (params = {}) =>
  commonService.post("/user/fetch_habits_all", params);

export const fetchUserGoals = (params = {}) =>
  commonService.post("/goal/fetch_since", params);

export const fetchUserSettings = (params = {}) =>
  commonService.post("/notification/fetch_user_setting", params);

export const editUserPrivacy = (params = {}) =>
  commonService.post("/notification/privacy", params);

export const fetchHeaderData = (params = {}) =>
  commonService.post("/user/update_hud", params);

// Blogs
export const fetchBlogCategories = (params = {}) =>
  commonService.post("blog/fetch_blog_categories", params);

export const fetchAllBlogs = (params = {}) =>
  commonService.post("blog/fetch_blog_all", params);

export const fetchBlogsByCategory = (params = {}) =>
  commonService.post("blog/fetch_blog_all", params);

export const fetchBookmarkedBlogs = (params = {}) =>
  commonService.post("blog/fetch_blog_bookmarks", params);

// Store
export const fetchStoreHomeComponents = (params = {}) =>
  commonService.post("/store/fetch_store_home_components", params);

// Chat
export const fetchChatMessages = (params = {}) =>
  commonService.post("/userchatconversation/fetch_chat", params);

// Home Page
export const fetchHomePageData = (params = {}) =>
  commonService.post("/generic/home_page_v1", params);

export const fetchEarningActivities = (params = {}) =>
  commonService.post("/goqiicash/fetch_reward_points_landing_v2", params);

export const fetchGoqiiCashTransactions = (params = {}) =>
  commonService.post("/goqiicash/fetch_goqiicash_history", params);

export const saveUserRating = (params = {}) =>
  commonService.post("/user/rate_session", params);

// Challenges
export const fetchChallengeData = (params = {}) =>
  commonService.post("challenge/challenge_landing_screen_v3", params);

export const fetchjoinChallengeData = (params = {}) =>
  commonService.post("challenge/join_challenge_by_id_v3", params);

// Generic Pages & Coaches
export const fetchgenericPageData = (params = {}) =>
  commonService.post("user/fetch_generic_page_info", params);

export const fetchcoachListData = (params = {}) =>
  commonService.post("user/selfassignment", params);

export const fetchcoachSelectionData = (params = {}) =>
  commonService.post("user/coachselection", params);

// Food
export const addFood = (params = {}) =>
  commonService.post("food/add_food", params);

export const updateCartV2 = (params = {}) =>
  commonService.post("store/update_cart_v2", params);


export const fetch_product_details = (params = {}) =>
  commonService.post("store/fetch_product_details", params);

export const fetch_cart_v2 = (params = {}) =>
  commonService.post("store/fetch_cart_v2", params);

export const initiate_partial_cart_payment_uht = (params = {}) =>
  commonService.post("store/initiate_partial_cart_payment_uht", params);

export const fetch_my_orders_v2 = (params = {}) =>
  commonService.post("store/fetch_my_orders_v2", params);

export const fetch_info = (params = {}) =>
  commonService.post("userchatconversation/fetch_info", params);

export const fetch_chat = (params = {}) =>
  commonService.post("userchatconversation/fetch_chat", params);

export const send_user_conversation = (params = {}) =>
  commonService.post("userchatconversation/send_user_conversation", params);

export const fetch_addresses = (params = {}) =>
  commonService.post("store/fetch_addresses", params);

export const add_address = (params = {}) =>
  commonService.post("store/add_address", params);

export const fetch_razorpay_orderid = (params = {}) =>
  commonService.post("razorpay/fetch_razorpay_orderid", params);

export const fetch_razorpay_transaction_status_v2 = (params = {}) =>
  commonService.post("razorpay/fetch_razorpay_transaction_status_v2", params);



export const apply_discount = (params = {}) =>
  commonService.post("store/apply_discount", params);


export const fetch_store_components_v2 = (params = {}) =>
  commonService.post("store/fetch_store_components_v2", params);
















